import Icon from '../components/Icon.vue'

Icon.register({
  'smile-beam': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM112 223.4c-0.7 8.5 10.8 11.9 15.1 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6 12.3 0 23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4.1 14.9-4.5-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4zM362.8 346.2c13.5-16.2-11-36.7-24.6-20.5-22.4 26.8-55.2 42.2-90.2 42.2s-67.8-15.3-90.2-42.2c-13.6-16.2-38.1 4.2-24.6 20.5 28.5 34.2 70.3 53.8 114.8 53.8s86.3-19.6 114.8-53.8zM369 227.9c4.1 7.4 15.7 4.1 15.1-4.5-3.3-42.1-32.2-71.4-56-71.4-23.8 0-52.7 29.3-56 71.4-0.7 8.5 10.8 11.8 14.9 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6z'
      }
    ]
  }
})
